import {
	Directive,
	Input,
	OnDestroy,
	OnInit,
	TemplateRef,
	ViewContainerRef,
} from '@angular/core';
import { SubSink } from 'subsink';

// --- Facades ---
import { AuthFacade } from '@facades/auth.facade';

// --- Services ---
import { LocalStorageService } from '@services/local-storage.service';

@Directive({
	selector: '[appClearIfHasFeature]',
})
export class ClearIfHasFeatureDirective implements OnInit, OnDestroy {
	@Input('appClearIfHasFeature') featureName!: string;
	private subs = new SubSink();

	readonly authState$ = this.authFacade.authState$;
	readonly tenant = this.localStorageService.get('tenant');

	constructor(
		private authFacade: AuthFacade,
		private localStorageService: LocalStorageService,
		private templateRef: TemplateRef<any>,
		private viewContainer: ViewContainerRef
	) {}

	ngOnInit() {
		this.subs.add(
			this.authFacade.authState$.subscribe(user => {
				this.viewContainer.remove();
				if (
					(this.tenant && this.tenant?.features?.[this.featureName]) ||
					this.tenant[this.featureName]
				) {
					this.viewContainer.clear();
				} else {
					this.viewContainer.createEmbeddedView(this.templateRef);
				}
			})
		);
	}

	ngOnDestroy(): void {
		this.subs.unsubscribe();
	}
}
